/**
 * Centralized AppShell detection utility.
 * Replaces scattered `window?.appshell?.isAppShell` checks throughout the codebase.
 */
export const isRunningInAppShell = () => !!window?.appshell?.isAppShell;
